export default function BootstrapDatepickerMinMaxValidator(userService) {
    'ngInject';

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elem, attrs, ctrl) {
                const regionalSettings = userService.getRegionalSettings();
                ctrl.$validators.dateMinMax = function(value) {
                    const minDate = scope.$eval(attrs.minDate);
                    const maxDate = scope.$eval(attrs.maxDate);
                    const date = moment(value, regionalSettings.dateFormat);

                    if (!date.isValid()) {
                        return false;
                    }

                    if (attrs.minDate && !(date.isAfter(minDate, 'day') || date.isSame(minDate, 'day'))) {
                        return false;
                    }

                    if (attrs.maxDate && !(date.isBefore(maxDate, 'day') || date.isSame(maxDate, 'day'))) {
                        return false;
                    }

                    return true;
                };
            },

        };
}



// WEBPACK FOOTER //
// ./src/app/directives/bootstrapDatepickerMinMaxValidator.directive.js